import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { Exclusions, ListingExclusions } from './types/Listing';

interface AdditionalParams {
  checkForConflicts?: boolean;
  actionToken?: string;
}

interface ListingExclusionsPayload {
  dates: Exclusions[];
  adjustDates?: boolean;
  params: AdditionalParams;
}

export const addListingExclusionsNext = (makeCall: MakeCall) => (
  listingId: number,
  payload: ListingExclusionsPayload,
) =>
  makeCall<ListingExclusions>(
    'POST',
    `${APIV2_URL}/listing/${listingId}/exclusions`,
    {
      data: {
        ...payload,
      },
      query: { adjustDates: payload.adjustDates || true },
    },
  );

export default (makeCall: MakeCall) => (
  listingId: number,
  exclusions: Exclusions[] = [],
  adjustDates: boolean = true,
) =>
  makeCall<ListingExclusions>(
    'POST',
    `${APIV2_URL}/listing/${listingId}/exclusions`,
    {
      data: exclusions,
      query: { adjustDates },
    },
  );
